/* BTTO desktop mega menu - hover/tab behaviour (replica of Qikify Smart Menu). */
(function () {
  if (window.__bttoMegaMenu) return;
  window.__bttoMegaMenu = true;

  var CLOSE_DELAY = 150;

  function place(item) {
    var sub = item.querySelector('.btto-mm__sub');
    if (!sub) return;
    var parent = sub.offsetParent || document.body;
    var pr = parent.getBoundingClientRect();
    var lr = item.getBoundingClientRect();
    sub.style.setProperty('--btto-mm-left', -pr.left + 'px');
    sub.style.setProperty('--btto-mm-top', lr.bottom - pr.top + 'px');
    sub.style.setProperty('--btto-mm-width', document.documentElement.clientWidth + 'px');
  }

  function activateTab(tab) {
    var sub = tab.closest('.btto-mm__sub');
    var id = tab.getAttribute('data-panel');
    if (!sub || !id) return;
    sub.querySelectorAll('.btto-mm__tab').forEach(function (t) { t.classList.toggle('is-active', t === tab); });
    sub.querySelectorAll('.btto-mm__panel').forEach(function (p) { p.classList.toggle('is-active', p.id === id); });
  }

  function init(nav) {
    if (nav.dataset.ready) return;
    nav.dataset.ready = '1';
    var items = nav.querySelectorAll('.btto-mm__item--tab');

    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var l = it.querySelector('.btto-mm__link');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
    }
    function open(item) {
      clearTimeout(item._t);
      closeAll(item);
      place(item);
      item.classList.add('is-open');
      item.querySelector('.btto-mm__link').setAttribute('aria-expanded', 'true');
    }
    function close(item) {
      if (item._pinned) return;
      item._t = setTimeout(function () {
        item.classList.remove('is-open');
        item.querySelector('.btto-mm__link').setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    }


    items.forEach(function (item) {
      var link = item.querySelector('.btto-mm__link');
      item.addEventListener('mouseenter', function () { open(item); });
      item.addEventListener('mouseleave', function () { close(item); });
      item.addEventListener('focusin', function () { open(item); });
      item.addEventListener('focusout', function (ev) {
        if (!item.contains(ev.relatedTarget)) close(item);
      });
      link.addEventListener('click', function (ev) {
        if (!link.hasAttribute('href')) {
          ev.preventDefault();
          item.classList.contains('is-open') ? close(item) : open(item);
        }
      });
      link.addEventListener('keydown', function (ev) {
        if ((ev.key === 'Enter' || ev.key === ' ') && !link.hasAttribute('href')) {
          ev.preventDefault();
          open(item);
        }
      });
      item.querySelectorAll('.btto-mm__tab[data-panel]').forEach(function (tab) {
        tab.addEventListener('mouseenter', function () { activateTab(tab); });
        tab.addEventListener('focusin', function () { activateTab(tab); });
      });
    });

    // Theme editor: selecting a block opens its dropdown / tab so it can be edited in place
    nav.addEventListener('shopify:block:select', function (ev) {
      var item = ev.target.closest('.btto-mm__item');
      if (!item || !item.classList.contains('btto-mm__item--tab')) return;
      open(item);
      item._pinned = true;
      var tab = ev.target.closest('.btto-mm__tab[data-panel]');
      if (tab) activateTab(tab);
    });
    nav.addEventListener('shopify:block:deselect', function (ev) {
      var item = ev.target.closest('.btto-mm__item');
      if (item) { item._pinned = false; close(item); }
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape') closeAll();
    });
    window.addEventListener('resize', function () {
      items.forEach(function (it) { if (it.classList.contains('is-open')) place(it); });
    });
  }

  function boot() { document.querySelectorAll('.btto-mm').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
